import axios, { AxiosInstance } from 'axios';
import { getTokens } from '../api/AuthService';

// Replace with your API base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Create an Axios instance
const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  // Optionally, set default headers here (excluding the token and x-api-key)
  headers: {
    'Content-Type': 'application/json',
  },
});

const exemptedUrls = [
  '/verify-token',
  '/status',
  '/user-types',
  '/request-invitation',
];

// Interceptor to add Cognito token and x-api-key to each request
axiosInstance.interceptors.request.use(
  async (config) => {
    // Get the Cognito token from localStorage or any other place you store it
    const isExempted = exemptedUrls.some((url) => config.url?.startsWith(url));

    const apiKey = process.env.REACT_APP_API_KEY;
    if (apiKey) {
      config.headers['x-api-key'] = apiKey;
    }
    if (isExempted) {
      return config; // Skip adding the token for exempted endpoints
    }
    try {
      const cognitoToken = await getTokens();

      if (config.headers) {
        if (cognitoToken?.idToken) {
          config.headers['Authorization'] = `Bearer ${cognitoToken.idToken}`;
        }
      }
    } catch (error) {
      console.error('Error fetching token:', error);
      // Optionally handle the error (e.g., redirect to login)
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    // Handle successful responses
    return response;
  },
  (error) => {
    // Handle response errors
    if (axios.isAxiosError(error)) {
      console.error('Global Axios error:', error);
      // You might want to dispatch an error action or show a global notification here
    } else {
      console.error('Global Non-Axios error:', error);
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
